import { GameSingletons } from "@game/app/GameSingletons";
import { StakingAddonStatusData_Unlocked } from "./models";

export function isUserOnVIPWhitelist(data: { vipWhitelist: StakingAddonStatusData_Unlocked["vipWhitelist"] }): boolean {
  const { contracts } = GameSingletons.getGameContext();
  return data.vipWhitelist.some(row => row.railroader === contracts.currentUserName);
}
